export { mdxComponent } from './syntax';
